<template>
    <!-- Edit Modal -->
<div class="modal fade p-0" id="companyBalanceProducts" tabindex="-1" aria-labelledby="editLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="d-flex flex-wrap w-100 position-relative event-auto">
			<div class="card shadow-none">
				<div class="card-header card-header-primary d-flex flex-wrap align-items-center position-relative">
					<div class="content-card-left">
						<h4 class="card-title text-white">Products Details</h4>
						<p class="fw-light text-white mb-0 pt-1" v-if="invoice_number">Invoice No: {{ invoice_number }}</p>
					</div>
				</div>
				<div class="card-body" >
					<div class="bill-wrapper">
						<div class="table-responsive mb-0">
							<table id="my-table"  class="custom-table billing-table">
								<thead>
									<tr>
										<th class="text-capitalize">Name</th>
                                        <th class="text-capitalize">Packing</th>
										<th class="text-capitalize">Quantity</th>
                                        <th class="text-capitalize">Amount</th>

									</tr>
								</thead>
								<tbody>
									<!-- Paid products first; free (extra) quantity is listed separately below. -->
									<tr v-for="product in visibleProducts" :key="product.id">
                  
										<td>{{product.name}}</td>
                                        <td>{{product.packing_type}}</td>
                                        <!-- Quantity = paid only (total minus free extra boxes). -->
										<td v-if="product.packing_type === 'boxes'">{{ paidQuantity(product) }}</td>
                                        <td v-if="product.packing_type === 'cartons'">{{ paidQuantity(product) / (Number(product.boxes_per_carton) || 1) }}</td>
                                        <!-- Carton lines use one rounded carton price x cartons;
                                             boxes use the box price. Free extra is excluded. -->
                                        <td>{{ lineAmount(product) }}</td>
                                    </tr>
										<!-- Free (extra) items given with this bill -->
										<template v-if="freeProducts.length">
											<tr class="fw-bold">
												<td colspan="4">Extra (free)</td>
											</tr>
											<tr v-for="(product, i) in freeProducts" :key="'free-' + i">
												<td>{{ product.name }}</td>
												<td>{{ product.extra_packing_type || 'boxes' }}</td>
												<td>{{ Number(product.extra_quantity) }}</td>
												<td>Free</td>
											</tr>
										</template>
								</tbody>
								<tfoot v-if="visibleProducts.length">
									<tr class="fw-bold">
										<td colspan="2">Total Boxes</td>
										<td colspan="2">{{ totalBoxes }}</td>
									</tr>
									<tr class="fw-bold">
										<td colspan="2">Total Cartons</td>
										<td colspan="2">{{ totalCartons }}</td>
									</tr>
								</tfoot>

							</table>

						</div>
                        <div class="row mt-2">
                            <div class="col-6"> feight: {{ total_freight }} <br> Discount: {{ total_discount }}</div>
                            <div class="col-6 text-end"> Intial Amount: {{ intial_amount }} <br>  Total Amount: {{ total_amount }}</div>

                            

                        </div>

					</div>
				</div>
			</div>
		</div>
	</div>			
</div>
</template>

<script>
import { ref, watch, computed } from 'vue';
import CompanyBalanceService from '@/services/CompanyBalanceService';
export default {
    props:{
        company_id: Number,
        parent_inventory_id: Number
    },
    setup(props,{emit}){
        const products=ref([]);
        const total_discount = ref(0)
        const total_amount = ref(0)
        const total_freight = ref(0)
        const intial_amount = ref(0)
        const invoice_number = ref('')
        // Free (extra) boxes for a row, converted to boxes. Old rows have no
        // extra split (null/0), so this is 0 and the whole quantity counts as paid.
        const freeBoxes = (p) => {
            const ex = Number(p.extra_quantity) || 0;
            if (ex <= 0) return 0;
            const bpc = Number(p.boxes_per_carton) || 1;
            return p.extra_packing_type === 'cartons' ? ex * bpc : ex;
        };
        // Paid quantity in boxes = total quantity minus the free portion.
        const paidQuantity = (p) => {
            const paid = (Number(p.quantity) || 0) - freeBoxes(p);
            return paid > 0 ? paid : 0;
        };
        // Show only rows that have a paid quantity (hide fully-free additions).
        const visibleProducts = computed(() =>
            products.value.filter((p) => paidQuantity(p) > 0)
        );
        // Rows with a free (extra) part, shown in their own "Extra (free)" section.
        const freeProducts = computed(() =>
            products.value.filter((p) => freeBoxes(p) > 0)
        );
        // Totals over every line (paid only), whatever it was bought in:
        // boxes = all paid boxes, cartons = each line's boxes / its boxes-per-carton.
        const totalBoxes = computed(() =>
            visibleProducts.value.reduce((sum, p) => sum + paidQuantity(p), 0)
        );
        const totalCartons = computed(() => {
            const cartons = visibleProducts.value.reduce(
                (sum, p) => sum + paidQuantity(p) / (Number(p.boxes_per_carton) || 1), 0
            );
            return Math.round(cartons * 100) / 100;
        });
        // Amount for a line: carton lines are priced per rounded carton
        // (round(box x bpc) x cartons) so they land clean; boxes use the box price.
        const lineAmount = (p) => {
            const box = Number(p.initial_price_per_unit) || 0;
            const bpc = Number(p.boxes_per_carton) || 1;
            if (p.packing_type === 'cartons') {
                const cartons = paidQuantity(p) / bpc;
                return Math.round(box * bpc) * cartons;
            }
            return p.pre_amount != null ? p.pre_amount : box * paidQuantity(p);
        };
        const closeModal= ()=>{
            const myModalEl = document.getElementById('companyBalanceProducts');
            if(!myModalEl) return;
            const modal = window.bootstrap.Modal.getInstance(myModalEl);
            modal?.hide();
        }
        watch(()=>props.parent_inventory_id, (currentValue, oldValue) => {
          if(currentValue!=oldValue && currentValue!="" && props.company_id>0){
            CompanyBalanceService.getTransactionsProduct(props.company_id,props.parent_inventory_id)
              .then(response=>{
                products.value=response.data;
                if(response.data && response.data.length > 0){
                  total_discount.value=response.data[0].total_discount;
                  total_amount.value=response.data[0].final_amount;
                  total_freight.value=response.data[0].total_freight;
                  intial_amount.value=response.data[0].intial_amount;
                  invoice_number.value=response.data[0].invoice_number || '';
                } else {
                  invoice_number.value='';
                  total_discount.value=0;
                  total_amount.value=0;
                  total_freight.value=0;
                  intial_amount.value=0;
                  closeModal();
                }
              })
              .catch(error => {
                if(error?.response?.status==404){
                  closeModal();
                  //emit('alertEvent', 'no_data');
                }
            });
          }
        });
        
        return{
            products,
            visibleProducts,
            freeProducts,
            totalBoxes,
            totalCartons,
            paidQuantity,
            lineAmount,
            total_discount,
            total_amount,
            closeModal,
            total_freight,
            intial_amount,
            invoice_number

        }
    }
}
</script>